<template >
  <div class="form-wrapper">
    <div class="ml-30 pt-30 brand-header">
        <md-dialog-title style="margin-left: -1rem; font-size: 2rem;" v-if="!id">{{options.Lang.neuesBranding}}</md-dialog-title>
        <md-dialog-title style="margin-left: -1rem; font-size: 2rem;" v-if="id">{{options.Lang.BrandingBearbeiten}}</md-dialog-title>
        <!-- Two tabs, ONE Save each: General (images, company, e-mail sender) and
             Texts & e-mails (per language). A "•" on a tab = unsaved changes there. -->
        <SegmentedTabs v-if="id" class="brand-header__tabs" v-model="activeTab" :tabs="mainTabs" />
        <div class="brand-header__actions">
          <CustomButton id="uploadButton" variant="primary" :label="saveLabel" :disabled="saving" @click="saveActiveTab" />
          <CustomButton variant="secondary" :label="options.Lang.Fenster_schließen" @click="close()" />
        </div>
      </div>
      <br>
      <div v-show="activeTab === 'general'" class="brand-form" style="background: white; padding: 2rem 1.5rem; margin-right: 3rem;">
        <!-- Branding assets: image uploads as preview cards -->
        <div v-if="id" class="bf-uploads">
          <CustomImagePicker
              ref="picker_logo"
              :label="options.Lang.Logo"
              :preview="logoNew"
              :browseLabel="options.Lang.Durchsuchen"
              :showUpload="false"
              :pendingLabel="options.Lang.image_pending || 'Saved with Save'"
              @change="onPickImage('logo', $event)" />

          <CustomImagePicker
              ref="picker_logoback"
              :label="options.Lang.LogoB"
              :preview="logoback"
              :browseLabel="options.Lang.Durchsuchen"
              :showUpload="false"
              :pendingLabel="options.Lang.image_pending || 'Saved with Save'"
              @change="onPickImage('logoback', $event)" />

          <CustomImagePicker
              ref="picker_favicon"
              :label="options.Lang.Favicon"
              :preview="logooo"
              :browseLabel="options.Lang.Durchsuchen"
              :showUpload="false"
              :pendingLabel="options.Lang.image_pending || 'Saved with Save'"
              @change="onPickImage('favicon', $event)" />

          <CustomImagePicker
              ref="picker_background"
              :label="options.Lang.default_back || 'Default Trips Background'"
              :preview="backDefault"
              :browseLabel="options.Lang.Durchsuchen"
              :showUpload="false"
              :pendingLabel="options.Lang.image_pending || 'Saved with Save'"
              @change="onPickImage('background', $event)" />
        </div>

        <!-- Company details: clean labeled field grid (3 per row) -->
        <div class="bf-grid">
          <CustomInput :label="options.Lang.Bezeichnung" v-model="address.bezeichnung" />
          <CustomInput :label="options.Lang.Firma" v-model="address.company" />
          <CustomColorInput :label="options.Lang.Primärfarbe" v-model="address.color" />
          <CustomInput :label="options.Lang.Straße" v-model="address.street" />
          <CustomInput :label="options.Lang.Plz" v-model="address.code" />
          <CustomInput :label="options.Lang.Ort" v-model="address.city" />
          <CustomInput :label="options.Lang.Telefon" v-model="address.telefon" />
          <CustomInput :label="options.Lang.Fax" v-model="address.fax" />
          <CustomInput :label="options.Lang.Email" v-model="address.email" type="email" />
          <CustomInput :label="options.Lang.reservation_email || 'Reservation Email'" v-model="address.reservation_email" type="email" />
          <!-- Checkout Profile: all checkout texts / questions / emails / PDF live in
               the selected profile (Extra Features → Checkout). Keeps this dialog tidy. -->
          <div class="bf-field" v-if="id">
            <label class="bf-label">{{ (options.Lang && options.Lang.CheckoutProfile) || 'Checkout Profile' }}</label>
            <CustomSelect
                v-model="address.checkout_profile_id"
                :options="checkoutProfileOptions"
                :placeholder="(options.Lang && options.Lang.none) || '— None —'" />
          </div>
          <div class="bf-field" v-if="id">
            <label class="bf-label">{{ options.Lang.Sprache_wählen_Frontend }}</label>
            <CustomSelect v-model="address.sprache" :options="languageOptions" />
          </div>
          <div class="bf-field" v-if="id">
            <label class="bf-label">{{ options.Lang.tripLang }}</label>
            <CustomSelect v-model="address.tripLang" :options="languageOptions" />
          </div>
          <!-- Client redesign opt-in: temporary select while old + new layout coexist.
               Remove together with the legacy layout (brandings.new_layout). -->
          <div class="bf-field" v-if="id" :title="options.Lang.new_layout_hint">
            <label class="bf-label">{{ options.Lang.new_layout_label || 'Client Layout' }}</label>
            <CustomSelect v-model="address.new_layout" :options="layoutOptions" />
          </div>
        </div>
        <!-- Per-branding e-mail sender (brandings.sender_*): own section, see
             components/branding/BrandingSenderSection.vue. Empty = global sender. -->
        <BrandingSenderSection
            v-if="id"
            :options="options"
            :mode.sync="senderMode"
            :defaultName="defaultSenderName"
            :defaultEmail="defaultSenderEmail"
            :senderName.sync="address.sender_name"
            :senderEmail.sync="address.sender_email" />
      </div>
      <Success class="errorDialog" v-if="options.showSuccess && options.user.loggedIn" :options="options"></Success>
      <Toast :show.sync="showToast" :message="toastMsg" type="success"
             :closeLabel="(options.Lang && options.Lang.close_window) || 'Close'" />
<div>
    </div>
    <!--Additional Informations (tab "Texts & e-mails")-->
    <div class="brandings" v-if="id" v-show="activeTab === 'texts'">
      <div class="brand-lang-bar">
        <h2 class="brand-name">{{ options.Lang.additional_info }}</h2>
        <LanguagePills
            v-if="brandingLanguages.length"
            :all="supportedLanguages"
            :active="brandingLangCodes"
            :value="activeBrandLang"
            :langLabels="(options.Lang && options.Lang.lang_code) || {}"
            :defaults="['en']"
            :addLabel="(options.Lang && options.Lang.add_lang) || 'Add language'"
            @input="activeBrandLang = $event"
            @add="onAddBrandLang"
            @remove="onRemoveBrandLang" />
      </div>
      <div class="brand-details">
        <template v-if="showTabs && brandingLanguages.length > 0">
          <template v-for="bralang in brandingLanguages">
            <div v-show="activeBrandLang === bralang.lang_code" :key="bralang.id">
              <AdditionalInformationTab
                ref="langTabs"
                :address="bralang.texts"
                :label="bralang.lang_code"
                :options.sync="options"
                :editors="bralang.editors"
                :hideSave="true"
                @deleted="handleModalClose"
                v-model:values="bralang.texts"
                @request-tab-delete="openTabDeleteConfirm"
                @dirty-change="onTabDirty(bralang.lang_code, $event)"
                @saved="onTabSaved"
              />
            </div>
          </template>
        </template>
        <DeleteConfirmation
            :showConfirm.sync="showTabDeleteConfirm"
            :confirmTitle="(options.Lang && options.Lang.delete_lang_title) || (options.Lang && options.Lang.title_delete_lang) || 'Remove language'"
            :confirmMessage="(options.Lang && options.Lang.delete_lang_msg) || (options.Lang && options.Lang.confirm_delete_lang) || 'Remove this language and all its content?'"
            :trans="options.Lang"
            @confirm="confirmRemoveBrandLang"
        />
      </div>
    </div>
  </div>
</template>
  
<script>

import { validationMixin } from 'vuelidate'
import Success from '../../components/dialogs/Success.vue'
import {EditorContent} from '@tiptap/vue-2'
import { createSimpleEditor, createRichEditor } from '../../utils/editorFactory'
import TextEditorBox from '@/components/basics/TextEditorBox.vue'
import AdditionalInformationTab from "../AdditionalInformationTab.vue";
import CreateTabModal from "./CreateTabModal.vue";
import LanguagePills from "../parts/LanguagePills.vue";
import CustomSelect from "../parts/CustomSelect.vue";
import CustomInput from "../parts/CustomInput.vue";
import CustomButton from "../parts/CustomButton.vue";
import CustomImagePicker from "../parts/CustomImagePicker.vue";
import CustomColorInput from "../parts/CustomColorInput.vue";
import BrandingSenderSection from "../branding/BrandingSenderSection.vue";
import SegmentedTabs from "../parts/SegmentedTabs.vue";
import leaveGuard from "../../utils/leaveGuard";
import i18n from "../../plugins/localization/i18n";
import DeleteConfirmation from "../modals/DeleteConfirmation.vue";
import Toast from "../parts/Toast.vue";
import store from '@/store';
export default {
  name: 'formGlobalInfo',
  mixins: [validationMixin],
  components: {
    DeleteConfirmation,
    AdditionalInformationTab, CreateTabModal, LanguagePills, CustomSelect,
    CustomInput, CustomButton, CustomImagePicker, CustomColorInput, Toast,
    Success, EditorContent,TextEditorBox, BrandingSenderSection, SegmentedTabs
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    logobackModel: null,
    emailBetreffSupplier_de: null,
    emailBetreffSupplier_en: null,
    emailBetreffCustomer_de: null,
    emailBetreffCustomer_en: null,
    emailSupplierSig_de: null,
    emailSupplierSig_en: null,
    showTabDeleteConfirm: false,
    tabToDeleteRef: null,
    showToast: false,
    toastMsg: '',
    logoNew: null,
    backDefault: null,
    logoback: null,
    favicon: null,
    // Data-URIs of freshly-picked images (set by CustomImagePicker @change),
    // read by the save* methods. Keeps the upload payload identical to before.
    pickedImages: { logo: null, logoback: null, favicon: null, background: null },
    suppsig: null,
    showEditMail: true,
    supportedLanguages: i18n.availableLocales,
    showAddLanguageModal: false,
    showTabs:true,
    ImageDone: false,
    editor:createSimpleEditor(),
    editor2:createSimpleEditor(),
    editor3:createSimpleEditor(),
    editor4:createSimpleEditor(),
    editor6:createSimpleEditor(),
    editor7:createSimpleEditor(),
    editor8:createSimpleEditor(),
    editor9:createSimpleEditor(),
    editor21:createRichEditor(),
    editor22:createRichEditor(),
    editor12:createSimpleEditor(),
    editor14:createSimpleEditor(),
    email: null,
    email2: null,
    address: {
      company: "",
      bezeichnung: "",
      tripLang:"",
      reiseversicherung: "",
      amt: "",
      mitarbeiterbezeichnung : "",
      mitarbeiterbezeichnungEng: "",
      street: "",
      reply: "",
      agbs: "",
      replyzugang: "",
      code: "",
      city: "",
      telefon: "",
      fax: "",
      vermittelt: "",
      email: "",
      datenschutz: "",
      impressum: "",
      color: "",
      sprache: "",
      signature: "",
      hello: "",
      helloeng: "",
      infoDocs: "",
      checkout_profile_id: null,
      // Client redesign opt-in (brandings.new_layout): 0 = legacy layout, 1 = modern.
      new_layout: 0,
      // Per-branding e-mail sender (brandings.sender_*); empty = global sender.
      sender_name: "",
      sender_email: "",
    },
    checkoutProfiles: [],
    logo: null,
    logoo: null,
    logooo: null,
    logoooooo: null,
    logo_placeholder: require('../../assets/images/camera-icon.svg'),
    demoText: "",
    tabValues: {
      subject:   '',
      signature: '',
      template:  ''
    },
    brandingLanguages: [],
    activeBrandLang: 'en',
    pendingRemoveLang: null,
    // Tabs + single Save: 'general' | 'texts'.
    activeTab: 'general',
    saving: false,
    // Unsaved-changes tracking. General: serialized address + picked images right
    // after load / save. Texts: reported per language by AdditionalInformationTab.
    generalClean: null,
    textsDirtyByLang: {},
    // E-mail sender toggle: 'default' (global address, fields saved as NULL) | 'custom'.
    senderMode: 'default',
    defaultSenderName: '',
    defaultSenderEmail: ''
  }),
  created() {
    this.setDemoText();
  },
  updated(){
    if(this.address.bezeichnung == null || this.address.bezeichnung == "" ||  this.address.bezeichnung == "null"){
      let button = document.getElementById("uploadButton")
      button.setAttribute("disabled", true)
    }else{
      let button = document.getElementById("uploadButton")
      button.removeAttribute("disabled")
    }
  },
  async mounted() {
    // Unsaved-changes guard: router navigation / close window ask via our modal.
    this.leaveGuardHandle = {
      isDirty: () => this.isDirty,
      prompt: (proceed, stay) => this.promptUnsaved(proceed, stay),
    };
    leaveGuard.register(this.leaveGuardHandle);
    this.options["brand_id"] = this.id;
    await this.getAllBrandings()
    await this.loadCheckoutProfiles()
    this.addBrandingLanguage()
    if(this.id == null){
      this.editor14.commands.setContent(this.demoText)
    }
    let self = this;
    if(self.id != null){
      let updateData = {
        id: self.id
      }
      await this.doPost({ data: updateData }, 'getSingleBranding', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          const arr = res?.data?.data
          if (!Array.isArray(arr) || arr.length === 0) {
           // console.log('getSingleBranding returned no data:', res)
            return
          }

          const result = arr[0]
          // Cache-buster: these images are served from files with stable names
          // (faviconBrand<id>.png etc.), so after re-upload the browser would show
          // the cached old image without a changing query param.
          const cacheBust = "?v=" + Date.now();
          self.address.company = result.bezeichnung;
          self.backDefault = result.default_trips_background
            ? process.env.VUE_APP_CRM_URL + "/titleImgs/" + result.default_trips_background + cacheBust
            : null;
          self.address.tripLang = result.tripLang;
          self.address.reiseversicherung = result.Reiseversicherung;
          self.address.amt = result.amt;
          self.address.bezeichnung = result.adresse;
          self.address.street = result.strasse;
          self.address.mitarbeiterbezeichnung = result.mitarbeiterbezeichnung;
          self.address.mitarbeiterbezeichnungEng = result.mitarbeiterbezeichnungEng;
          self.address.code = result.plz;
          self.address.city = result.stadt;
          self.address.telefon = result.telefon;
          self.address.fax = result.fax;
          self.address.email = result.email;
          self.address.reservation_email = result.reservation_email;
          self.address.sender_name = result.sender_name || "";
          self.address.sender_email = result.sender_email || "";
          self.senderMode = result.sender_email ? 'custom' : 'default';
          self.defaultSenderName = result.default_sender_name || '';
          self.defaultSenderEmail = result.default_sender_email || '';
          self.address.checkout_profile_id = result.checkout_profile_id || null;
          self.address.vermittelt = result.vermittelt;
          self.address.datenschutz = result.datenschutz;
          self.address.impressum = result.impressum;
          self.address.agbs = result.agbs;
          self.logoNew = result.baseLogo;
          self.logooo = result.favicon
            ? process.env.VUE_APP_CRM_URL + "/titleImgs/faviconBrand" + self.id + "." + result.favicon + cacheBust
            : null;
          self.logoback = result.logoback
            ? process.env.VUE_APP_CRM_URL + "/titleImgs/logoBackBranding" + result.id + "." + result.logoback + cacheBust
            : null;
          self.address.color = result.color;
          self.address.new_layout = result.new_layout ? 1 : 0;
          self.address.sprache = result.sprache;
          self.address.reply = result.reply;
          self.address.replyzugang = result.replyzugang;


          self.address.signature = result.signature;
          self.address.hello = result.hello;
          self.address.helloeng = result.helloeng;
          self.email = result.emailCustomer_de;
          self.email2 = result.emailCustomer_en;
          self.emailBetreffSupplier = result.emailBetreffSupplier;
          self.emailBetreffSupplier_en = result.emailBetreffSupplier_en;
          self.emailBetreffCustomer = result.emailBetreffCustomer;
          self.emailBetreffCustomer_en = result.emailBetreffCustomer_en;
          self.emailSupplierSig_de = result.emailSupplierSig_de;
          self.emailSupplierSig_en = result.emailSupplierSig_en;

          self.editor3.commands.setContent(result.hello);
          self.editor12.commands.setContent(result.helloeng);
          self.editor14.commands.setContent(result.infoDocs);
          self.editor4.commands.setContent(result.signature);
          self.editor.commands.setContent(result.emailCustomer);
          self.editor2.commands.setContent(result.emailCustomer_en);
          self.editor6.commands.setContent(self.emailBetreffSupplier);
          self.editor7.commands.setContent(self.emailBetreffSupplier_en);
          self.editor8.commands.setContent(self.emailBetreffCustomer);
          self.editor9.commands.setContent(self.emailBetreffCustomer_en);
          self.editor21.commands.setContent(self.emailSupplierSig);
          self.editor22.commands.setContent(self.emailSupplierSig_en);
          self.address['betreffSupplierEmail'] = result.emailBetreffSupplier;
          if(result.infoDocs == '<p></p>') {
            self.editor14.commands.setContent(self.demoText)
          }
            self.tabValues = {
              subject:   self.emailBetreffCustomer || '',
              signature: self.emailSupplierSig  || '',
              template:  self.email                   || ''
            }
            // Everything above was the load, not user input: this is the clean state.
            self.markGeneralClean();



        }
      });
    }
    
     let edits = document.querySelectorAll(".ProseMirror"); 
      edits.forEach(element =>{
        element.style.minHeight= "200px";
        element.style.maxHeight= "200px";
        element.style.overflow= "scroll";
        element.style.maxWidth = "";
        element.style.minWidth = "95%";
        element.style.marginLeft = "0";
      })
  },
  watch: {
    emailBetreffCustomer_de(v) { this.tabValues.subject = v },
    emailSupplierSig_de(v)    { this.tabValues.signature = v },
    email(v)                  { this.tabValues.template = v },
    clear() {
    }
  },
  computed: {
    // Lang codes that currently have a branding_languages row (for the pills).
    brandingLangCodes() {
      return this.brandingLanguages.map(l => l.lang_code);
    },
    // Options for the CustomSelect dropdowns.
    checkoutProfileOptions() {
      const none = { value: null, label: (this.options.Lang && this.options.Lang.none) || '— None —' };
      return [none].concat((this.checkoutProfiles || []).map(cp => ({ value: cp.id, label: cp.name })));
    },
    languageOptions() {
      const map = (this.options.Lang && this.options.Lang.lang_code) || {};
      return (this.brandingLanguages || []).map(l => ({
        value: l.lang_code || 'en',
        label: map[l.lang_code] || (l.lang_code || 'en')
      }));
    },
    // Legacy vs. modern client layout (brandings.new_layout: 0 / 1). Temporary
    // while both layouts coexist — remove together with the legacy layout.
    layoutOptions() {
      const Lang = this.options.Lang || {};
      return [
        { value: 0, label: Lang.layout_legacy || 'Legacy Layout' },
        { value: 1, label: Lang.layout_modern || 'Modern Layout' }
      ];
    },
    // ---- tabs / unsaved changes ----
    generalSignature() {
      // Picked images are data-URIs (can be MBs): only their presence/size counts,
      // so a keystroke in the form never re-serializes the image data.
      const imgs = Object.keys(this.pickedImages).map(k => (this.pickedImages[k] ? this.pickedImages[k].length : 0));
      return JSON.stringify([this.address, imgs, this.senderMode]);
    },
    generalDirty() {
      return this.generalClean !== null && this.generalSignature !== this.generalClean;
    },
    textsDirty() {
      return Object.values(this.textsDirtyByLang).some(Boolean);
    },
    isDirty() {
      return this.generalDirty || this.textsDirty;
    },
    mainTabs() {
      const L = this.options.Lang || {};
      const mark = d => (d ? ' •' : '');
      return [
        { value: 'general', label: (L.branding_tab_general || 'General') + mark(this.generalDirty) },
        { value: 'texts', label: (L.branding_tab_texts || 'Texts & e-mails') + mark(this.textsDirty) },
      ];
    },
    saveLabel() {
      const L = this.options.Lang || {};
      return this.activeTab === 'texts' ? (L.save_texts || 'Save texts') : (L.Speichern || 'Save');
    }
  },
  beforeDestroy() {
    leaveGuard.unregister(this.leaveGuardHandle);
  },
  methods: {
    onTabSaved() {
      // Feedback is the toast in saveTexts(); nothing else to do here.
    },
    // Add a branding language: create its row, refresh tabs, select it.
    onAddBrandLang(lang) {
      const self = this;
      const data = { lang_code: lang, brand_id: this.id, user_id: this.options.user.id };
      this.doPost({ data }, 'branding/languages/createTab', async function (res) {
        if (res && res.msg !== 'success' && res.data && res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
          return;
        }
        await self.remountTabs();
        self.activeBrandLang = lang;
      });
    },
    // Remove a branding language (defaults like 'en' are blocked by the pills).
    // Confirm first — deleting a language drops all its content.
    onRemoveBrandLang(lang) {
      this.pendingRemoveLang = lang;
      this.showTabDeleteConfirm = true;
    },
    confirmRemoveBrandLang() {
      const lang = this.pendingRemoveLang;
      this.pendingRemoveLang = null;
      if (!lang) return;
      const self = this;
      const data = { lang_code: lang, brand_id: this.id, user_id: this.options.user.id };
      this.doPost({ data }, 'branding/languages/deleteTab', async function () {
        if (self.activeBrandLang === lang) self.activeBrandLang = 'en';
        await self.remountTabs();
      });
    },
    // Load the list of checkout profiles for the branding's profile selector.
    async loadCheckoutProfiles() {
      const self = this;
      await this.doPost({}, 'checkout-profiles', function (res) {
        if (res.data.status !== 'error') {
          self.checkoutProfiles = res.data.data || [];
        }
      });
    },
    openTabDeleteConfirm(tabRef) {
      this.tabToDeleteRef = tabRef;
      this.showTabDeleteConfirm = true;
    },
    confirmTabDelete() {
      if (this.tabToDeleteRef?.confirmDeletion) {
        this.tabToDeleteRef.confirmDeletion();
        this.tabToDeleteRef = null;
      }
    },
    addBrandingLanguage(){
      //console.log(i18n.availableLocales);
    },
    async remountTabs() {
      this.textsDirtyByLang = {};
      this.showTabs = false;
      await this.$nextTick();
      await this.getAllBrandings();
      this.showAddLanguageModal = false;
      this.showTabs = true;
    },
    addImage(){
      const url = prompt('Enter the image URL')
      if (url) {
        this.editor21.value.chain().focus().setImage({ src: url }).run()
      }
    },
    async handleModalClose() {
      await this.remountTabs();
    },
    async saveVorlagenBetreff(){
      let newValues = {
        id: this.id,
        newBetreffSupplierDe: this.editor6.getHTML(),
        newBetreffSupplierEn: this.editor7.getHTML()
      }
      let self = this;
      await this.doPost({data: newValues}, 'setBetreffSupplier', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
        }
      });
    },
    async getAllBrandings(){
      const self = this;

      if(!this.id || this.id == null){
        return;
      }
      await this.doPost({brandId: this.id}, `branding/languages`, function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          const defaultFields = {
            company: "", bezeichnung: "", reiseversicherung: "", amt: "", mitarbeiterbezeichnung: "", mitarbeiterbezeichnungEng: "",
            street: "", reply: "", agbs: "", replyzugang: "", code: "", city: "", telefon: "", fax: "", vermittelt: "", email: "",
            datenschutz: "", impressum: "", color: "", sprache: "", signature: "", hello: "", helloeng: "", infoDocs: "",
            // Per-language [title] salutation override — declared so texts.salutation
            // is Vue-2 reactive even on languages saved before the feature existed.
            salutation: null,
            // Checkout text fields — declared here so they're present (and Vue-2
            // reactive) on the texts object even when a language has none yet.
            checkout_payment_label: "", checkout_name_heading: "", checkout_name_confirm: "",
            checkout_agb_heading: "", checkout_agb_link: "", checkout_datenschutz_link: "",
            checkout_formblatt_link: "", checkout_insolvenz_link: "", formblatt_pdf: "", insolvenz_pdf: ""
          };
          self.tabValues = { ...defaultFields, ...self.tabValues };
          const sortedData = [...res.data.data].sort((a, b) => {
            if (a.lang_code === 'en') return -1;
            if (b.lang_code === 'en') return 1;
            return 0;
          });
          self.brandingLanguages = sortedData.map(lang => ({
            ...lang,
            texts: { ...defaultFields, ...lang.texts },
            editors: {
              subject: createSimpleEditor(lang.texts.emailBetreffCustomer || ''),
              signatureSupplier: createSimpleEditor(lang.texts.emailSupplierSig || '', true),
              template: createSimpleEditor(lang.texts.emailCustomer || ''),
              reservationEmailBody: createRichEditor(lang.texts.reservation_email_body || ''),
              infoDocs: createSimpleEditor(lang.texts.infoDocs || ''),
              travelReqMsg: createSimpleEditor(lang.texts.travel_req_msg || ''),
              welcomeText: createRichEditor(lang.texts.hello || ''),
              welcomeTextBooked: createRichEditor(lang.texts.hello_booked || ''),
              signature: createSimpleEditor(lang.texts.signature || ''),
              extra_content: createRichEditor(lang.texts.extra_content || ''),
              // Checkout long-form texts (rich editors). Short labels stay plain
              // inputs bound to `address.*` and are saved alongside in texts.
              checkout_insurance_confirm: createSimpleEditor(lang.texts.checkout_insurance_confirm || ''),
              checkout_payment_confirm: createSimpleEditor(lang.texts.checkout_payment_confirm || ''),
              checkout_name_text: createSimpleEditor(lang.texts.checkout_name_text || ''),
              checkout_agb_confirm: createSimpleEditor(lang.texts.checkout_agb_confirm || ''),
            }
          }));
          // Keep the selected language pill valid after (re)load.
          const codes = self.brandingLanguages.map(l => l.lang_code);
          if (!codes.includes(self.activeBrandLang)) {
            self.activeBrandLang = codes.includes('en') ? 'en' : (codes[0] || 'en');
          }
        }
      });
    },
    async saveVorlagenBetreff2(){
      let newValues = {
        id: this.id,
        newBetreffCustomerDe: this.editor8.getHTML(),
        newBetreffCustomerEn: this.editor9.getHTML()
      }
      let self = this;
      await this.doPost({data: newValues}, 'setBetreffCustomer', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
        }
      });
    },
    async saveVorlagenBetreff3(){
      let newValues = {
        id: this.id,
        newBetreffCustomerDe: this.editor21.getHTML(),
        newBetreffCustomerEn: this.editor22.getHTML()
      }
      let self = this;
      await this.doPost({data: newValues}, 'setSupplierSig', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
        }
      });
    },
    async saveVorlagen(){
      let newValues = {
        id: this.id,
        newEmailDe: this.editor.getHTML(),
        newEmailEn: this.editor2.getHTML()
      }
      let self = this;
      await this.doPost({data: newValues}, 'setdbmails', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
        }
      });
    },
    async getDbMails(){
      let self = this;
      await this.doPost({}, 'getdbmails', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let dbmails = res.data.data;
          self.email = dbmails[0].emailCustomer_de
          self.email2 = dbmails[0].emailCustomer_en
          self.getEmails();
        }
      });
    },
    getEmails() {
      this.editor.commands.setContent(this.email);
      this.editor2.commands.setContent(this.email2);

      this.editor6.commands.setContent(this.emailBetreffSupplier);
      this.editor7.commands.setContent(this.emailBetreffSupplier_en);
      this.editor8.commands.setContent(this.emailBetreffCustomer);
      this.editor9.commands.setContent(this.emailBetreffCustomer_en);
      this.editor21.commands.setContent(this.emailSupplierSig);
      this.editor22.commands.setContent(this.emailSupplierSig_en);




      let edits = document.querySelectorAll(".ProseMirror"); 
        edits.forEach(element =>{
          element.style.minHeight= "220px"; // overflow: scroll;";
          element.style.maxHeight= "220px";
          element.style.overflow= "scroll";
          element.style.maxWidth = "";
          element.style.minWidth = "95%";
          element.style.marginLeft = "0";
        })
    },
    closeEdit(){
      this.showEditMail = false;
      this.editor.commands.setContent(this.email);
      this.editor2.commands.setContent(this.email2);
      let edits = document.querySelectorAll(".ProseMirror"); 
        edits.forEach(element =>{
          element.style.minHeight= "13rem"; // overflow: scroll;";
          element.style.maxHeight= "13rem";
          element.style.overflow= "scroll";
          element.style.maxWidth = "16.5rem";
          element.style.minWidth = "16.5rem";

        })
    },
    // ---- tabs / single Save -------------------------------------------------
    markGeneralClean() {
      this.generalClean = this.generalSignature;
    },
    onTabDirty(langCode, dirty) {
      this.$set(this.textsDirtyByLang, langCode, !!dirty);
    },
    async saveActiveTab() {
      if (this.saving) return;
      this.saving = true;
      try {
        if (this.activeTab === 'texts') {
          await this.saveTexts();
        } else {
          await this.saveGeneral();
        }
      } finally {
        this.saving = false;
      }
    },
    // General tab: picked images first (each its own endpoint), then the branding
    // row incl. e-mail sender. Aborts before the row when an upload fails.
    async saveGeneral() {
      const ok = await this.uploadPickedImages();
      if (!ok) return;
      const saved = await this.save();
      if (saved) this.markGeneralClean();
    },
    // Texts tab: saves EVERY language with unsaved changes (not only the visible
    // one), so switching languages before Save loses nothing.
    async saveTexts() {
      const tabs = [].concat(this.$refs.langTabs || []);
      const dirty = tabs.filter(t => t && t.isDirty);
      if (dirty.length === 0) {
        this.toastMsg = (this.options.Lang && this.options.Lang.nothing_to_save) || 'No changes to save.';
        this.showToast = true;
        return;
      }
      let allOk = true;
      for (const tab of dirty) {
        const ok = await tab.submitTabContent();
        if (!ok) allOk = false;
      }
      if (allOk) {
        this.toastMsg = (this.options.Lang && this.options.Lang.texts_saved) || 'Texts saved.';
        this.showToast = true;
      }
    },
    // Our confirm modal (options.globalConfirm), never window.confirm.
    promptUnsaved(proceed, stay) {
      const L = this.options.Lang || {};
      const gc = this.options.globalConfirm;
      const done = (fn) => { gc.visible = false; gc.onConfirm = null; gc.onCancel = null; fn(); };
      Object.assign(gc, {
        visible: true,
        styled: false,
        showInput: false,
        hideCancel: false,
        title: L.unsaved_changes_title || 'Unsaved changes',
        message: L.unsaved_changes_text || 'There are unsaved changes. Leave without saving?',
        confirmBtnText: L.leave_without_saving || 'Leave without saving',
        confirmBtnClass: 'md-raised md-accent',
        onConfirm: () => done(proceed),
        onCancel: () => done(stay),
      });
    },
    async save() {
      let self = this;
      self.address.signature = this.editor4.getHTML(),
      self.address.hello = this.editor3.getHTML(),
      self.address.helloeng = this.editor12.getHTML(),
      self.address.infoDocs = this.editor14.getHTML()

      let updateData = {
        brandId: this.id,
        adresse: this.address.bezeichnung,
        tripLang: this.address.tripLang || 'en',
        bezeichnung: this.address.company,
        strasse: this.address.street,
        plz: this.address.code,
        stadt: this.address.city,
        telefon: this.address.telefon,
        fax: this.address.fax,
        email: this.address.email,
        reservation_email: this.address.reservation_email,
        // 'default' sender = both NULL (backend then uses the global address).
        sender_name: this.senderMode === 'custom' ? ((this.address.sender_name || '').trim() || null) : null,
        sender_email: this.senderMode === 'custom' ? ((this.address.sender_email || '').trim() || null) : null,
        checkout_profile_id: this.address.checkout_profile_id || null,
        color: this.address.color,
        new_layout: this.address.new_layout ? 1 : 0,
        sprache: this.address.sprache || 'en',
        user: this.options.user.id,
        vermittelt: this.address.vermittelt,
      }
      let saved = false;
      await this.doPost({ data: updateData }, this.id == null ? 'newBranding' : 'updateBranding', res => {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
          console.error(res)
        } else {
          saved = true;
          // New branding: adopt the returned id so the form stays open and becomes an
          // in-place edit (image uploads etc. now have an id). No page reload.
          if (self.id == null && res.data.data && res.data.data.insertId) {
            self.id = res.data.data.insertId;
            self.options.brand_id = self.id;
          }
          // Lightweight toast instead of the blocking Success modal — the form
          // stays open, no redirect.
          self.toastMsg = (self.options.Lang && self.options.Lang.branding_saved) || 'Branding saved.';
          self.showToast = true;
          self.$emit('brand-updated', {
            id: self.id,
            adresse: self.address.bezeichnung
          });
        }
      });
      await self.setPdfStatus();
      return saved;
    },
    async setPdfStatus(){
      let data = {
        tripId : "all",
        status : "false"
      }
      await this.doPost({ data: data }, 'setStatusPdf', function (res) {
            if (res.data.status === 'error') {
              self.help.log(self.$t(res.msg), false, true);
            } else {
              let result = res.data.data
            }
          });
    },
    abort() {
      window.setTimeout(function(){location.reload();}, 1000)
    },
    close(){
      leaveGuard.confirmLeave(() => {
        this.options.showBrandForm = false;
        this.options.showBrandSettings = true;
      });
    },
    getImg(event) {
      this.logo = event.target.files[0]; // Extract file from event
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logo = e.target.result; // Update logoback with the image data URL
      };
      reader.readAsDataURL(this.logo);
      this.logoReader = reader
    },
    getDefaultImg(event) {
      this.backDefault = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.backDefault = e.target.result; // Update logoback with the image data URL
      };
      reader.readAsDataURL(this.backDefault);
      this.defaultBackReader = reader
    },
    getImgback(event) {
      this.logoback = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logoback = e.target.result; // Update logoback with the image data URL
      };
      reader.readAsDataURL(this.logoback); // Correct: use the file, not unrelated variable
      this.logoBackReader = reader
    },
    getFavicon(event) {
      this.logooo = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logooo = e.target.result; // Update logoback with the image data URL
      };
      reader.readAsDataURL(this.logooo);
      this.logoFavReader = reader
    },
    getSuppSig(event) {
      this.logoooooo = event.target.files[0];
    },
    // Store a freshly-picked image's data-URI for the matching save method.
    onPickImage(kind, payload) {
      this.$set(this.pickedImages, kind, payload && payload.dataUrl);
    },
    // Staged uploads: every picked image goes to its own endpoint (same payloads
    // as before) when the General tab is saved. Resolves false on the first error.
    async uploadPickedImages() {
      const self = this;
      const jobs = [
        { kind: 'logo',       endpoint: 'uploadLogoBrand',          ref: 'picker_logo' },
        { kind: 'logoback',   endpoint: 'uploadLogobackBrand',      ref: 'picker_logoback' },
        { kind: 'favicon',    endpoint: 'uploadFaviconBrand',       ref: 'picker_favicon', withUser: true },
        { kind: 'background', endpoint: 'upload/defaultbackground', ref: 'picker_background' },
      ];
      for (const job of jobs) {
        const baseFile = self.pickedImages[job.kind];
        if (!baseFile) continue;
        const myData = { baseFile, id: self.id };
        if (job.withUser) myData.user_id = self.options.user.id;
        let ok = false;
        await self.doPost({ data: myData }, job.endpoint, function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            ok = true;
            self.$set(self.pickedImages, job.kind, null);
            self.$refs[job.ref] && self.$refs[job.ref].clearPending();
          }
        });
        if (!ok) return false;
      }
      return true;
    },
    async saveSuppSig() {
      let self = this;
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
      async function Main(blub) {
        const file = blub;
        let baseFile = await toBase64(file);
        let myData={
          baseFile: baseFile,
          id: self.id
        }
        await self.doPost({ data: myData }, 'uploadSuppSigBrand', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.options.showSuccess = true;
          }
        });
       
      }

      await Main(this.logoooooo);
     
      self.options.showSuccess = true;
    },
    openDialog() {
    },
    closeDialog() {
      this.options.showGlobalInfoForm = false;
    },
    refreshDialog() {
      let self = this;
      self.options.showGlobalInfoForm = false;
      self.$nextTick(() => {
        // Adding the component back in
        self.options.showGlobalInfoForm = true;
      });
    },
    setDemoText() {
      this.demoText = `
      Hallo [title] [name],
      <br><br>
      Gerne möchten wir Ihnen hier einige Erläuterung zu den beschriebenen Leistungen geben. :
      <br><br>
      Keine Kontingente:
      <br><br>
      Bitte beachten Sie, dass wir aufgrund unserer Individualität keinerlei Kontingente auf die Landleistungen haben, so dass ich Ihnen bei Angebotserstellung nicht die Verfügbarkeit garantieren kann. Leistungen werden bei uns erst nach Zugang Ihrer schriftlichen Anmeldung angefragt und dann verbindlich reserviert. Sollten einzelne Leistungen aufgrund einer kurzfristigen Buchung bereits ausgebucht sein, suchen wir nach Rücksprache mit Ihnen nach einer geeigneten Alternative.
      <br><br>
      Transfers:
      <br><br>
      Die Transfers vom Flughafen zum Hotel oder der jeweiligen Mietwagenstation sind nicht automatisch in unserem Angebot eingeschlossen, außer es ist unter den Leistungen separat vermerkt. Wir empfehlen Ihnen diese meist sehr kurzen Distanzen mit einem Taxi oder Shuttle-Bus zurückzulegen, da dies nach unserer Erfahrung eine problemlose, schnelle und preiswerte Möglichkeit bietet.
      `;
    },
   
  }
}
</script>
<style>
/* ===== Branding main form — clean flat layout (matches the language section tabs) ===== */
.brand-form { border-radius: 1rem; }

/* Image-upload preview cards */
.brand-form .bf-uploads {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}
@media (max-width: 1100px) { .brand-form .bf-uploads { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 600px)  { .brand-form .bf-uploads { grid-template-columns: 1fr; } }
.brand-form .bf-upload {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: #fafafa;
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  padding: 1rem;
}
.brand-form .bf-upload__label { font-size: 0.78rem; font-weight: 600; color: #555; }
.brand-form .bf-upload__preview {
  width: 100%;
  height: 170px;            /* taller so square logos/images sit nicely */
  border-radius: 8px;
  background: #fff;
  border: 1px solid #ececec;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0.5rem;
  box-sizing: border-box;
}
.brand-form .bf-upload__preview img { max-width: 100%; max-height: 100%; object-fit: contain; }
.brand-form .bf-upload__empty { color: #c4c4c4; font-size: 1.5rem; }
.brand-form .bf-upload__file { width: 100% !important; min-height: 0; margin: 0; }
.brand-form .bf-upload__btn { margin: 0 !important; align-self: flex-start; min-width: 130px; height: 36px; }

/* Company-detail field grid (3 per row, like General & Legal) */
.brand-form .bf-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem 1.5rem;
}
@media (max-width: 1100px) { .brand-form .bf-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 700px)  { .brand-form .bf-grid { grid-template-columns: 1fr; } }
.brand-form .bf-field { display: flex; flex-direction: column; min-width: 0; }
.brand-form .bf-label { font-size: 0.78rem; font-weight: 600; color: #555; margin-bottom: 0.3rem; }
.brand-form .bf-input {
  width: 100%;
  height: 44px !important;
  border: 1px solid #dcdcdc !important;
  border-radius: 8px !important;
  padding: 0 0.85rem !important;
  font-size: 0.9rem;
  line-height: 44px !important;
  background: #fafafa;
  box-sizing: border-box !important;
  min-height: 0 !important;
}

/* (Selects now use the CustomSelect component — no md-select overrides needed.) */

/* Header action buttons (Save + Close, top-right) */
.brand-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.brand-header__actions { display: flex; gap: 0.75rem; margin-right: 3rem; }
.brand-header__tabs { margin: 0 1.5rem; }

.fileField{
  width: 55% !important;
}

.ProseMirror {        
  min-height: 13rem;
  min-width: 16.5rem;
  max-width: 16.5rem;
  overflow-x: scroll;
  overflow-y: hidden;
  max-height:  13rem;
}

.ProseMirror img{
  height: 25% !important;
  width: 25% !important;
}

::-webkit-scrollbar {
    display: none;
}
#emailvorlage{
  margin-left: 3rem;
  margin-right: 3rem;
  margin-top: 2rem;
}
.editCat{
  z-index: 111111;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: transparent;
}
.bgEdit{
  background-color: rgb(94, 94, 94);
  padding-top: 1rem;
  padding-bottom: 1rem;
  height: 100%;
  width: 100%;
  opacity: 0.5;
}

#divEmail{
  background: white;
  width: 107%;
  padding: 3rem;
  margin-left: -3rem;
  padding-bottom: 5rem;
}

.areaa{
  padding: 10px 10px !important;
background-color: #F5F6FA !important;
line-height: 20px;
height: 52px;
font-size: 14px !important;
color: #202224 !important;
border: 0.6px solid #D5D5D5;
-webkit-text-fill-color: #A6A6A6 !important;
border-radius: 4px;
box-shadow: none !important;
-webkit-box-shadow: none !important;
max-width: 100% !important;
min-width: 100% !important;
font-family: inherit;
}

.contentEdit{
  margin-top: -14rem;
  padding: 3rem;
  background-color: white;
  width: 90%;
  height: 80%;
  left: 5%;
}
.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
}

.choose-file::file-selector-button {
  font-weight: bold;
  color: #202224;
  font-family: "Nunito", sans-serif !important;
  font-size: 14px !important;
  background-color: #E1E8F3;
  padding: 10px 24px;
  outline: none;
  border: none;
  border-radius: 10px;
  width: 155px;
  height: 38px;
  display: inline-block;
  margin-top: 8px;
}

.choose-file::file-selector-button:hover{
 cursor:pointer;
 background-color: #c9cbce;
}

#sigfield{
  z-index: 111111;
}

#logo{
  width: 100% !important;
}

#logoback{
  width: 100% !important;
}

.secondary,
.button-save {
  height: 38px !important;
}

.imglogoback{
  max-width: 100% !important;
  max-height: 100% !important;
}

.ProseMirror table{
  color: red !important;
}

.uploadedLogo{
  display: flex;
  justify-content: center;
  align-items: center;
  background: #E1E8F3;
  height: 260px;
  width: 284px;
  margin-top: 10px;
  margin-bottom: 10px;
}


#hello .ProseMirror{
  height: 10rem !important;
  width: 100% !important
}

#helloeng .ProseMirror{
  height: 10rem !important;
  width: 100% !important
}

#street,#plz,#company,#tel,#fax,#city,#email,#impressum,#datenschutz,#color,#signature, #hello, #helloeng, #reply, #replyzugang, #agbs, #vermittelt, #bezeichnung, #reiseversicherung, #amt, #infoDocs, #mitarbeiterbezeichnung, #mitarbeiterbezeichnungEng{
  -webkit-text-fill-color: black !important;
}
.button-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 3rem;
  padding: 1rem 3rem;
}
.md-tabs-navigation {
  background-color: #616161; /* Grey 700 - a good real grey */
  color: white; /* Optional if you want white text on grey */
  border-radius: 0;
}
</style>